export default "/images/cmmc__discover_icon.png";